module.exports = __webpack_public_path__ + "static/media/ve.05045bce.svg";